import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function BarcodeScannerPage() {
  const [data, setData] = useState('No result');
  const [isScanning, setIsScanning] = useState(false);
  const [permissionDenied, setPermissionDenied] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState('');
  const html5QrcodeScannerRef = useRef(null);

  useEffect(() => {
      if (isScanning) {
      const config = { fps: 10, qrbox: 250, facingMode: "environment", formatsToSupport: [
        Html5QrcodeSupportedFormats.CODE_128,
        Html5QrcodeSupportedFormats.CODE_39,
        Html5QrcodeSupportedFormats.EAN_13,
        Html5QrcodeSupportedFormats.EAN_8,
        Html5QrcodeSupportedFormats.UPC_A,
        Html5QrcodeSupportedFormats.UPC_E,
        Html5QrcodeSupportedFormats.ITF,
        Html5QrcodeSupportedFormats.CODABAR,
        Html5QrcodeSupportedFormats.QR_CODE
      ] };
      console.log("Starting scanner with config:", config);
      html5QrcodeScannerRef.current = new Html5Qrcode("reader");

      html5QrcodeScannerRef.current.start(
        { facingMode: "environment" },
        config,
        async (decodedText, decodedResult) => {
          console.log("Decoded text:", decodedText);
          setData(decodedText);

          // Mock submission to backend (commented out real API call)
          /*
          try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/barcode`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify({ userId: 1, barcodeData: decodedText }),
            });
            if (response.ok) {
              setSubmissionStatus('Barcode data submitted successfully');
            } else {
              setSubmissionStatus('Failed to submit barcode data');
            }
          } catch (err) {
            setSubmissionStatus('Error submitting barcode data');
          }
          */

          // Mock success submission
          setSubmissionStatus('Barcode data submitted successfully (mock)');

          // Stop scanning after successful scan
          if (html5QrcodeScannerRef.current) {
            html5QrcodeScannerRef.current.stop().then(() => {
              html5QrcodeScannerRef.current.clear();
              html5QrcodeScannerRef.current = null;
              setIsScanning(false);
            }).catch(err => {
              console.error('Failed to stop scanning after success:', err);
            });
          }
        },
        (errorMessage) => {
          // suppress frequent "no match" errors to reduce console noise
          if (!errorMessage.includes('No barcode or QR code detected') && !errorMessage.includes('NotFoundException')) {
            console.warn('QR Code no match:', errorMessage);
          }
        }
      ).catch(err => {
        console.error('Unable to start scanning:', err);
        setPermissionDenied(true);
        setIsScanning(false);
      });
    } else {
      if (html5QrcodeScannerRef.current) {
        html5QrcodeScannerRef.current.stop().then(() => {
          html5QrcodeScannerRef.current.clear();
          html5QrcodeScannerRef.current = null;
        }).catch(err => {
          console.error('Failed to stop scanning:', err);
        });
      }
    }
    // Cleanup on unmount
    return () => {
      if (html5QrcodeScannerRef.current) {
        html5QrcodeScannerRef.current.stop().then(() => {
          html5QrcodeScannerRef.current.clear();
          html5QrcodeScannerRef.current = null;
        }).catch(err => {
          console.error('Failed to stop scanning:', err);
        });
      }
    };
  }, [isScanning]);

  const handleToggleScanning = () => {
    if (!isScanning) {
      setPermissionDenied(false);
      setIsScanning(true);
      setSubmissionStatus('');
    } else {
      if (html5QrcodeScannerRef.current) {
        html5QrcodeScannerRef.current.stop().then(() => {
          html5QrcodeScannerRef.current.clear();
          html5QrcodeScannerRef.current = null;
          setIsScanning(false);
          setSubmissionStatus('');
        }).catch(err => {
          console.error('Failed to stop scanning:', err);
        });
      } else {
        setIsScanning(false);
        setSubmissionStatus('');
      }
    }
  };

  return (
    <Container style={{ maxWidth: 600, padding: 20, backgroundColor: '#1e1e2f', borderRadius: 8, color: '#f0f0f5' }}>
      <Row className="justify-content-center">
        <Col xs={12} md={8} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <h2 style={{ color: '#61dafb', textAlign: 'center', marginBottom: 20 }}>Barcode Scanner</h2>
          {permissionDenied && (
            <p style={{ color: 'red', fontWeight: 'bold' }}>
              Camera access denied or unable to start scanner. Please allow camera permissions in your browser settings.
            </p>
          )}
          <div id="reader" style={{ width: '100%', height: 300, borderRadius: 8, boxShadow: '0 0 10px #61dafb', overflow: 'hidden', position: 'relative', maxWidth: '100%', maxHeight: 300, objectFit: 'contain' }} />
          <style>{`
            #reader video {
              object-fit: contain !important;
              width: 100% !important;
              height: 300px !important;
              border-radius: 8px !important;
            }
          `}</style>
          <button onClick={handleToggleScanning} style={{ marginTop: 15, width: '100%', padding: '10px', fontSize: 16, fontWeight: 'bold', color: '#fff', backgroundColor: '#61dafb', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
            {isScanning ? 'Stop Scanning' : 'Start Scanning'}
          </button>
          <p style={{ marginTop: 15, fontSize: 16, fontWeight: 'bold', color: '#a0d8f7' }}>Scanned Data: {data}</p>
          <p style={{ marginTop: 10, fontSize: 14, fontWeight: 'bold', color: submissionStatus.includes('successfully') ? '#4caf50' : '#f44336' }}>{submissionStatus}</p>
        </Col>
      </Row>
    </Container>
  );
}

export default BarcodeScannerPage;
